<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "../components/loader";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxFilterRow,
  DxStateStoring,
  DxRemoteOperations,
  DxSelection,
} from "devextreme-vue/data-grid";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import DxPopup from "devextreme-vue/popup";
import DxDateBox from "devextreme-vue/date-box";
import api from "@/axios";
import Swal from "sweetalert2";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import moment from "moment";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {getBaseUrl} from "@/helpers/baseUrl";
import {ref} from "vue";
import DropZone from "@/components/widgets/dropZone.vue";

export default {
  components: {
    DxDropDownButton,
    DxRemoteOperations,
    Layout,
    PageHeader,
    Loader,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxExport,
    DxFilterRow,
    DxToolbar,
    DxItem,
    DxButton,
    DxStateStoring,
    DxSelection,
    DxPopup,
    DxDateBox,
    DropZone
  },
  setup() {
    let dropzoneFile = ref("");
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
    };
    const onDrop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    return { dropzoneFile, selectedFile, onDrop };
  },
  data() {
    return {
      title: "Comissões Calc.",
      items: [
        { text: "Comissões", href: "/comissoes/list" },
        { text: "Comissões Calc.", active: true },
      ],
      loading: true,
      comissoes: [],
      represList: [],
      equipeList: [],
      empresaList: [],
      showModalComissao: false,
      showEditModal: false,
      newComissao: {
        idRepres: null,
        vlrVenda: null,
      },
      editData: {},

      dataList: null,
      updating: false,
      showModalPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      represSelected: 'TD',
      equipeSelected: 'TD',

      showModalErros: false,
      dtListErrors: [],

      // Modal edição de comissão calculada
      showModalEditarCalc: false,
      editarCalcData: {
        id: null,
        repres_nome: '',
        tarifa: 0,
        debito: 0,
        credito: 0,
        retencao_perc: 20,
        empresa_emitente_id: null,
        observacao: '',
      },
      salvandoEdicao: false,

      showModalEfetivar: false,
      efetivandoComissoes: false,
      efetivarResumo: [],

      showImportModal: false,
      importLoading: false,

      showModalCampanhaHist: false,
      campanhaHistData: [],
      filtroHist: {
        di: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        df: moment().format('YYYY-MM-DD'),
        lote: '',
      },
      loadingHist: false,
    };
  },

  created() {

  },
  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted comissoes-calc')
    this.atualizaDataList();
    this.carregarEmpresas();
  },

  methods: {

    carregarEmpresas() {
      api.get(`${getBaseUrl()}api/empresas`).then(res => {
        this.empresaList = res.data[0] ?? res.data ?? [];
      }).catch(() => {});
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    onFilterRepres(e){
      console.log('onFilterRepres')
      console.log(e.itemData)
      const represSelcted = e.itemData;
      this.represSelected = represSelcted;

      this.atualizaDataList();
    },

    onFilterEquipe(e){
      console.log('onFilterEquipe')
      console.log(e.itemData)
      const equipeSelcted = e.itemData;
      this.equipeSelected = equipeSelcted;

      this.atualizaDataList();
    },

    onRowDblClick(e) {
      const row = e.data;
      if (!row) return;
      if (row.status === 'EF') {
        Swal.fire({ icon: 'info', title: 'Comissão já efetivada', text: 'Comissões efetivadas não podem ser editadas.', showConfirmButton: true });
        return;
      }
      this.editarCalcData = {
        id: row.comissaocalc_id,
        repres_nome: row.repres_nome ?? '',
        tarifa: row.tarifa ?? 0,
        debito: row.debito ?? 0,
        credito: row.credito ?? 0,
        retencao_perc: row.retencao_perc ?? 20,
        empresa_emitente_id: row.empresa_emitente_id ?? null,
        observacao: row.observacao ?? '',
      };
      this.showModalEditarCalc = true;
    },

    salvarEdicaoCalc() {
      this.salvandoEdicao = true;
      api.post(`${getBaseUrl()}api/editarcomissaocalc`, this.editarCalcData)
        .then(res => {
          if (res.data.success) {
            Swal.fire({ position: 'top-end', icon: 'success', title: 'Comissão atualizada!', showConfirmButton: false, timer: 2000 });
            this.showModalEditarCalc = false;
            this.atualizaDataList();
          } else {
            Swal.fire({ position: 'top-end', icon: 'warning', title: res.data.message, showConfirmButton: false, timer: 3000 });
          }
        }).catch(() => {
          Swal.fire({ icon: 'error', title: 'Erro ao salvar edição.', showConfirmButton: true });
        }).finally(() => { this.salvandoEdicao = false; });
    },

    abrirImportarCampanha() {
      this.showImportModal = true;
      this.dropzoneFile = "";
    },

    downloadModelo() {
      api.get(`${getBaseUrl()}api/exportarmodelocampanha`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, 'modelo_campanha.xlsx');
        })
        .catch(() => {
          Swal.fire("Erro", "Não foi possível baixar o modelo.", "error");
        });
    },

    processarImportacao() {
      if (!this.dropzoneFile || !this.dropzoneFile.name) {
        Swal.fire("Atenção", "Por favor, selecione um arquivo primeiro.", "warning");
        return;
      }
      const formData = new FormData();
      formData.append('arquivo', this.dropzoneFile);
      const idsCalc = (this.dataList ?? []).map(r => r.comissaocalc_id);
      formData.append('idsCalc', JSON.stringify(idsCalc));
      
      this.importLoading = true;
      api.post(`${getBaseUrl()}api/importarcampanha`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          if (res.data.success) {
            this.showImportModal = false;
            this.dropzoneFile = "";
            Swal.fire({ position: 'top-end', icon: 'success', title: res.data.message, showConfirmButton: false, timer: 3000 });
            this.atualizaDataList();
            if (this.showModalCampanhaHist) this.carregarCampanhaHist();
          } else {
            Swal.fire({ icon: 'warning', title: res.data.message, showConfirmButton: true });
          }
        }).catch(() => {
          Swal.fire({ icon: 'error', title: 'Erro ao importar campanha.', showConfirmButton: true });
        }).finally(() => {
          this.importLoading = false;
        });
    },

    abrirCampanhaHist() {
      this.showModalCampanhaHist = true;
      this.carregarCampanhaHist();
    },

    carregarCampanhaHist() {
      this.loadingHist = true;
      api.get(`${getBaseUrl()}api/getcampanhahist`, {
        params: {
          di: this.filtroHist.di,
          df: this.filtroHist.df,
          lote: this.filtroHist.lote
        }
      }).then(res => {
        this.campanhaHistData = res.data;
      }).catch(() => {
        Swal.fire("Erro", "Não foi possível carregar o histórico.", "error");
      }).finally(() => {
        this.loadingHist = false;
      });
    },

    abrirEfetivar() {
      const selectedKeys = this.dataGrid.getSelectedRowKeys();
      if (!selectedKeys || selectedKeys.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Selecione ao menos uma comissão para efetivar.', showConfirmButton: true });
        return;
      }
      const selectedIdSet = new Set(selectedKeys);
      this.efetivarResumo = (this.dataList ?? []).filter(r => selectedIdSet.has(r.comissaocalc_id));
      this.showModalEfetivar = true;
    },

    confirmarEfetivar() {
      const ids = this.efetivarResumo.map(r => r.comissaocalc_id);
      this.efetivandoComissoes = true;
      api.post(`${getBaseUrl()}api/efetivacomisscalc`, {
        'idsData': ids,
        'stsComisCalc': 'EF',
      }).then(res => {
        if (res.data.success === true) {
          Swal.fire({ position: 'top-end', icon: 'success', title: 'Comissões efetivadas com sucesso!', text: res.data.message, showConfirmButton: false, timer: 3000 });
        } else {
          Swal.fire({ position: 'top-end', icon: 'warning', title: res.data.message, showConfirmButton: false, timer: 3000 });
        }
        this.showModalEfetivar = false;
        this.atualizaDataList();
      }).catch(() => {
        Swal.fire({ icon: 'error', title: 'Erro ao efetivar comissões.', text: 'Não foi possível efetivar as comissões. Contate o suporte!', showConfirmButton: true });
      }).finally(() => { this.efetivandoComissoes = false; });
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'findi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'findf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    atualizaDataList(){
      console.log('atualizaDataList_comissaoCalc')
      this.loading = true;
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'findi': perIniPadrao,
          'findf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['findi']
        this.dtFimFiltro = filtros['findf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      const paramsReq = {
        'di': di,
        'df': df,
        'represSelected': this.represSelected.id,
        'equipeSelected': this.equipeSelected.id,
      }

      console.log('paramsReq: ' , paramsReq)
      api.get(`${getBaseUrl()}api/comissaocalc`, {
        params: paramsReq
      }).then(response => {
        console.log('response.data')
        console.log(response.data)
        this.dataList = response.data[0];
        const represList = response.data[2] ?? []
        const eqiupeList = response.data[3] ?? []
        this.represList = [{id: 'TD', descricao: 'Selecionar Todos'}, ...represList];
        this.equipeList = [{id: 'TD', nome: 'Selecionar Todos'}, ...eqiupeList];

        this.loading = false;
      })
      .catch((error) => {
        console.error("Erro ao buscar comissões:", error);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Erro ao carregar comissões",
          text: "Não foi possível carregar as comissões. Tente novamente mais tarde.",
          showConfirmButton: true,
        });
        this.loading = false;
      });
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Comissões Calc.: ${dtIniFormated} - ${dtFimFormated}`
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const status = e.data.status

          let corStatus = 'rgba(248,178,58,0.82)'

          switch (status) {
            case 'EF':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'NEF':
              corStatus = 'rgba(248,178,58,0.82)'
              break
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        if (e.column.dataField === "sts_comislider") {
          const stsComissaoLider = e.data.sts_comislider

          let corStatus = 'rgba(248,178,58,0.82)'

          switch (stsComissaoLider) {
            case true:
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case false:
              corStatus = 'rgba(248,178,58,0.82)'
              break
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        if (e.column.dataField === "financeiro_stsbaixa") {

          let dataAtual = new Date(Date.now())
          dataAtual.setDate(dataAtual.getDate() + 1)

          const vencimentoParc = Date.parse(e.data.financeiro_vencimento)
          const baixaParcStatus = e.data.financeiro_stsbaixa

          let corStatus = 'rgba(248,178,58,0.82)'

          if(baixaParcStatus === 'AB' && (vencimentoParc < dataAtual)){
            corStatus = 'rgba(223,121,106,0.98)'
          } else {
            switch (baixaParcStatus) {
              case 'QT':
                corStatus = 'rgba(46,184,134,0.96)'
                break
              case 'AB':
                corStatus = 'rgba(248,178,58,0.82)'
                break
              case 'AG':
                corStatus = 'rgba(101,166,249,0.82)'
                break
            }
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    nomeStatus(e) {
      if (e.value === "EF") {
        return 'Efetivado'
      } else {
        return 'Não Efetivado'
      }
    },

    nomeStsComisLider(e) {
      if (e.value === true) {
        return 'Gerado'
      } else {
        return 'Não gerado'
      }
    },

    nomeStatusBaixa(baixa) {
      baixa.value = baixa.value ?? 'Não gerado'
      switch (baixa.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AB':
          return 'Em Aberto'
        case 'AG':
          return 'Agendado'
        case 'QT':
          return 'Quitado'
      }

      return baixa.value
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    limiteDebito50(inadimplencia) {
      return ((inadimplencia ?? 0) * 0.5).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <Loader v-if="loading" style="min-height: 400px;"></Loader>

    <div v-if="!loading">
      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
            icon="refresh"
            hint="Atualizar lista"
            :on-click="atualizaDataList"
          />
        </DxItem>

        <DxItem location="before" widget="dxButton">
          <DxButton
            icon="event"
            hint="Histórico de Campanhas"
            text="Campanhas"
            :on-click="abrirCampanhaHist"
          />
        </DxItem>

        <DxItem location="before" widget="dxButton">
          <DxButton
            icon="check"
            hint="Efetivar Comissão"
            text="Efetivar Comissão"
            :on-click="abrirEfetivar"
          />
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxDropDownButton
              v-model="represSelected"
              :items="represList"
              :drop-down-options="{ width: 150 }"
              :style="{ maxWidth: '180px' }"
              icon="user"
              :text="represSelected.descricao ?? 'Selectione Repres.'"
              show-arrow="false"
              hint="Filtrar Representante"
              display-expr="descricao"
              value-expr="id"
              @item-click="onFilterRepres"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxDropDownButton
              v-model="equipeSelected"
              :items="equipeList"
              :drop-down-options="{ width: 150 }"
              :style="{ maxWidth: '180px' }"
              icon="group"
              :text="equipeSelected.nome ?? 'Selectione Equipe'"
              show-arrow="false"
              hint="Filtrar Equipe"
              display-expr="nome"
              value-expr="id"
              @item-click="onFilterEquipe"/>
        </DxItem>
      </DxToolbar>
    </div>

    <div v-if="!loading">
      <DxDataGrid
        ref="dataGridRefKey"
        :data-source="dataList"
        :keyExpr="'comissaocalc_id'"
        :show-borders="true"
        :focused-row-enabled="true"
        :column-auto-width="true"
        :show-row-lines="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        @content-ready="carregouGrid"
        @cell-prepared="onCellPrepared"
        @exporting="onExporting"
        @row-dbl-click="onRowDblClick">

        <DxSelection mode="multiple" show-check-boxes-mode="always" />

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxFilterRow :visible="true" />

        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovList"/>

        <DxColumn
            data-field="comissaocalc_id"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="repres_id"
            caption="Repres. ID"
            alignment="right"
            data-type="number"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="repres_nome"
            caption="Repres. Nome"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="sts_comislider"
            caption="Comis. Líder"
            alignment="center"
            data-type="text"
            :customize-text="nomeStsComisLider"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="financeiro_id"
            caption="Financ. ID"
            alignment="right"
            data-type="number"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_emissao"
            caption="Emissão Financ."
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_vencimento"
            caption="Vencimento Financ."
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_stsbaixa"
            caption="Status Financ."
            alignment="center"
            data-type="text"
            :customize-text="nomeStatusBaixa"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="comissaocalc_vlrcomissao"
            caption="Vlr. Comissão"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comissaocalc_qtdped"
            caption="Qtd. Pedido"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="comissaocalc_vlrvenda"
            caption="Vlr. Venda"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comissaocalc_percent"
            caption="Vlr. Percent."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="represtime_id"
            caption="Equipe ID"
            alignment="right"
            data-type="number"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="represtime_nome"
            caption="Equipe"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="campanha_bonus"
            caption="Campanha"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="campanha_lote"
            caption="Campanha Lote"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tarifa"
            caption="Tarifa"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="debito"
            caption="Débito"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="credito"
            caption="Crédito"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="retencao_perc"
            caption="Retenção %"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="total_saldo_retido"
            caption="Total Saldo Retido"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="inadimplencia_atual"
            caption="Inadimplência Atual"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldo_a_reter_pagar"
            caption="Saldo a Reter/Pagar"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="vlr_real"
            caption="ValorReal Comissão Calc."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criação"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

      </DxDataGrid>
    </div>

    <!-- Modal: Período de Exibição -->
    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro" class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro" class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Editar Comissão Calculada (duplo-clique) -->
    <b-modal
        v-model="showModalEditarCalc"
        title="Editar Comissão Calculada"
        size="md"
        centered
        hide-footer>
      <div v-if="editarCalcData.repres_nome" class="mb-3">
        <strong>Representante:</strong> {{ editarCalcData.repres_nome }}
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label>Empresa Emitente</label>
            <select v-model="editarCalcData.empresa_emitente_id" class="form-control">
              <option :value="null">— Selecione a Empresa Emitente —</option>
              <option v-for="emp in empresaList" :key="emp.id" :value="emp.id">
                {{ emp.nome ?? emp.descricao ?? emp.id }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label>Crédito</label>
            <input v-model="editarCalcData.credito" type="number" step="0.01" class="form-control" placeholder="0,00"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label>Débito</label>
            <input v-model="editarCalcData.debito" type="number" step="0.01" class="form-control" placeholder="0,00"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label>Tarifa</label>
            <input v-model="editarCalcData.tarifa" type="number" step="0.01" class="form-control" placeholder="0,00"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label>Retenção %</label>
            <input v-model="editarCalcData.retencao_perc" type="number" step="0.01" class="form-control" placeholder="20"/>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label>Observações</label>
            <textarea v-model="editarCalcData.observacao" class="form-control" rows="4" placeholder="Observações..."></textarea>
          </div>
        </div>
      </div>
      <div class="text-end mt-3">
        <b-button variant="light" @click="showModalEditarCalc = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button variant="success" class="ms-1" :disabled="salvandoEdicao" @click="salvarEdicaoCalc">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          {{ salvandoEdicao ? 'Salvando...' : 'Salvar' }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Confirmar Efetivação (somente visual) -->
    <b-modal
        v-model="showModalEfetivar"
        title="Confirmar Efetivação de Comissões"
        size="xl"
        centered
        hide-footer>
      <p class="text-muted mb-3">Revise o resumo abaixo antes de confirmar. Esta ação é irreversível.</p>
      <div class="table-responsive">
        <table class="table table-bordered table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th>ID</th>
              <th>Representante</th>
              <th class="text-end">Vlr. Comissão</th>
              <th class="text-end">Campanha</th>
              <th class="text-end">Tarifa</th>
              <th class="text-end">Débito</th>
              <th class="text-end">Crédito</th>
              <th class="text-end">Saldo a Reter/Pagar</th>
              <th class="text-end">ValorReal Comissão</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in efetivarResumo" :key="row.comissaocalc_id">
              <td>{{ row.comissaocalc_id }}</td>
              <td>{{ row.repres_nome }}</td>
              <td class="text-end">{{ formatDecimal(row.comissaocalc_vlrcomissao) }}</td>
              <td class="text-end">{{ formatDecimal(row.campanha_bonus) }}</td>
              <td class="text-end">{{ formatDecimal(row.tarifa) }}</td>
              <td class="text-end">{{ formatDecimal(row.debito) }}</td>
              <td class="text-end">{{ formatDecimal(row.credito) }}</td>
              <td class="text-end">{{ formatDecimal(row.saldo_a_reter_pagar) }}</td>
              <td class="text-end"><strong>{{ formatDecimal(row.vlr_real) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-end mt-4">
        <b-button variant="light" @click="showModalEfetivar = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button variant="success" class="ms-1" :disabled="efetivandoComissoes" @click="confirmarEfetivar">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          {{ efetivandoComissoes ? 'Efetivando...' : 'Confirmar Efetivação' }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal: Erros -->
    <b-modal
        v-model="showModalErros"
        id="showModalErros"
        size="lg"
        title="Erros gerados na ação"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Erro</th>
                    <th>DetalheErro</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrors" :key="data.id">
                    <td>{{data.error}}</td>
                    <td>{{data.msgError}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <DxPopup
      v-model:visible="showImportModal"
      title="Importar Campanha"
      :width="900"
      :height="'auto'"
      :show-title="true"
      :centered="true"
      :drag-enabled="false"
      :hide-on-outside-click="false"
    >
      <div class="p-2">
        <div class="text-center mb-4">
          <div class="avatar-lg mx-auto mb-3">
            <div class="avatar-title bg-soft-success rounded-circle text-success h1" style="font-size: 50px;">
              <i class="mdi mdi-microsoft-excel"></i>
            </div>
          </div>
          <h4 class="fw-bold">Importação de Campanha</h4>
          <p class="text-muted mx-auto" style="max-width: 400px;">Siga os passos abaixo para atualizar as campanhas (bônus) calculadas usando a planilha modelo.</p>
        </div>

        <div class="row g-4 mb-4">
          <div class="col-md-5">
            <div class="card h-100 border-0 bg-light shadow-none" style="border-radius: 16px;">
              <div class="card-body p-4 d-flex flex-column">
                <div class="mb-3">
                  <span class="badge bg-primary rounded-pill px-3 mb-2">Passo 1</span>
                  <h5 class="fw-bold mt-2">Baixar Modelo</h5>
                  <p class="small text-muted">Use nossa planilha padrão. Ela já vem preenchida com todos os Representantes, Equipes, e fórmulas de Total a Receber.</p>
                </div>
                <b-button variant="info" class="mt-auto shadow-sm w-100 py-2 fw-bold" style="border-radius: 10px;" @click="downloadModelo">
                  <i class="bx bx-download me-2 font-size-18 align-middle"></i> Modelo (.xlsx)
                </b-button>
              </div>
            </div>
          </div>

          <div class="col-md-7">
            <div class="card h-100 border-0 bg-light shadow-none" style="border-radius: 16px;">
              <div class="card-body p-4">
                <div class="mb-3">
                  <span class="badge bg-success rounded-pill px-3 mb-2">Passo 2</span>
                  <h5 class="fw-bold mt-2">Enviar Arquivo</h5>
                  <p class="small text-muted">Arraste a planilha preenchida ou clique no campo abaixo.</p>
                </div>
                
                <DropZone @change="selectedFile" @drop.prevent="onDrop" class="mb-2" />
                
                <div v-if="dropzoneFile && dropzoneFile.name" class="mt-2 p-2 bg-white rounded border d-flex align-items-center">
                  <i class="mdi mdi-file-excel-outline text-success font-size-24 me-2"></i>
                  <div class="overflow-hidden">
                    <div class="text-truncate fw-medium">{{ dropzoneFile.name }}</div>
                    <small class="text-muted">{{ (dropzoneFile.size / 1024).toFixed(1) }} KB</small>
                  </div>
                  <button class="btn btn-link text-danger ms-auto p-0" @click="dropzoneFile = ''">
                    <i class="mdi mdi-close"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 p-3 bg-light border-top" style="margin: 0 -1.5rem -1.5rem -1.5rem; border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;">
          <b-button variant="link" class="text-muted fw-bold" @click="showImportModal = false">Cancelar</b-button>
          <b-button :disabled="importLoading || !dropzoneFile || !dropzoneFile.name" variant="success" class="px-5 shadow-sm fw-bold" style="border-radius: 10px;" @click="processarImportacao">
            <span v-if="importLoading">
               <i class="bx bx-loader bx-spin font-size-18 align-middle me-2"></i> Processando...
            </span>
            <span v-else>
               <i class="mdi mdi-check-all me-1 font-size-18 align-middle"></i> Confirmar Importação
            </span>
          </b-button>
        </div>
      </div>
    </DxPopup>

    <!-- Modal Histórico de Campanhas -->
    <DxPopup
      v-model:visible="showModalCampanhaHist"
      :drag-enabled="false"
      :show-title="true"
      title="Histórico de Campanhas"
      :width="1200"
      :height="800"
    >
      <div class="p-2">
        <div class="row mb-3 align-items-end">
          <div class="col-md-4">
            <label>Data Inicial</label>
            <DxDateBox v-model="filtroHist.di" type="date" display-format="dd/MM/yyyy" @value-changed="carregarCampanhaHist" />
          </div>
          <div class="col-md-4">
            <label>Data Final</label>
            <DxDateBox v-model="filtroHist.df" type="date" display-format="dd/MM/yyyy" @value-changed="carregarCampanhaHist" />
          </div>
          <div class="col-md-4 text-end">
            <DxButton icon="upload" text="Importar Campanha" type="success" @click="abrirImportarCampanha" />
          </div>
        </div>

        <loader v-if="loadingHist" />

        <DxDataGrid
          v-if="!loadingHist"
          :data-source="campanhaHistData"
          :show-borders="true"
          :column-auto-width="true"
          :height="600"
          :row-alternation-enabled="true"
        >
          <DxPaging :page-size="20" />
          <DxPager
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 20, 50, 100]"
            :show-info="true"
            info-text="Página {0} de {1} ({2} itens)"
          />
          <DxFilterRow :visible="true" />
          <DxColumnChooser :enabled="true" mode="select" />
          <DxColumnFixing :enabled="true" />

          <DxColumn data-field="created_at" caption="Data Importação" data-type="datetime" format="dd/MM/yyyy HH:mm" sort-order="desc" :fixed="true" />
          <DxColumn data-field="lote" caption="Lote" :fixed="true" />
          <DxColumn data-field="repres_nome" caption="Representante" :fixed="true" />
          <DxColumn data-field="repres_equipe" caption="Equipe" />
          <DxColumn data-field="classe" caption="Classe" :visible="false" />
          
          <DxColumn data-field="nome_premio1" caption="Nome Prêmio 1" :visible="true" />
          <DxColumn data-field="vlr_premio1" caption="Vlr. Prêmio 1" :format="formatDecimal" :visible="true" />
          
          <DxColumn data-field="nome_premio2" caption="Nome Prêmio 2" :visible="true" />
          <DxColumn data-field="vlr_premio2" caption="Vlr. Prêmio 2" :format="formatDecimal" :visible="true" />
          
          <DxColumn data-field="nome_premio3" caption="Nome Prêmio 3" :visible="true" />
          <DxColumn data-field="vlr_premio3" caption="Vlr. Prêmio 3" :format="formatDecimal" :visible="true" />

          <DxColumn data-field="totalvendasmes" caption="Total Vendas" :format="formatDecimal" />
          <DxColumn data-field="totalareceber" caption="Total a Receber" :format="formatDecimal" />
          <DxColumn data-field="created_by" caption="Importado por" />
        </DxDataGrid>
      </div>
    </DxPopup>

  </Layout>
</template>
